export class AnnotationTypes {
    static required: string = 'required';
    static minLength: string = 'minLength';
    static maxLength: string = 'maxLength';
    static minNumber: string = 'minNumber';
    static maxNumber: string = 'maxNumber';
    static pattern: string = 'pattern';
    static compare: string = 'compare';
    static minDate: string = 'minDate';
    static maxDate: string = 'maxDate';
    static alpha: string = 'alpha';
    static alphaNumeric: string = 'alphaNumeric';
    static email: string = 'email';
    static hexColor: string = 'hexColor';
    static lowercase: string = 'lowercase';
    static url: string = 'url';
    static uppercase: string = 'uppercase';
    static nested: string = 'nested';
    static contains: string = 'contains';
    static range: string = 'range';
    static numeric: string = 'numeric';
}
